import { PRGlassProperties } from '@sketch-hq/sketch-web-renderer'
import { Point } from '../../../../../../../inspector'

export interface CopyProps {
  type: string
  radius?: number
  saturation?: number
  motionAngle?: number
  center?: Point
}

const copy = ({ type, radius, saturation, motionAngle, center }: CopyProps) => {
  let sectionCopyValue = `Type: ${type}`
  if (radius) {
    sectionCopyValue += `\nValue: ${radius}`
  }
  if (saturation) {
    sectionCopyValue += `\nSaturation: ${saturation}%`
  }
  if (motionAngle) {
    sectionCopyValue += `\nAngle: ${motionAngle}°`
  }
  if (center && ((center.x && center.y) || center.x === 0 || center.y === 0)) {
    sectionCopyValue += `\nOrigin: (${center.x}, ${center.y})`
  }
  return sectionCopyValue
}

export const copyGlass = ({
  brightness,
  distortion,
  depth,
  chromaticAberration,
  saturation,
}: PRGlassProperties) => {
  let sectionCopyValue = ''

  if (brightness) {
    sectionCopyValue += `\nBrightness: ${(brightness * 100).toFixed(0)}%`
  }
  if (distortion) {
    sectionCopyValue += `\nDistortion: ${distortion.toFixed(1)}`
  }
  if (depth) {
    sectionCopyValue += `\nDepth: ${(depth * 10).toFixed(0)}`
  }
  if (chromaticAberration) {
    sectionCopyValue += `\nChromatic Aberration: ${chromaticAberration}`
  }
  if (saturation) {
    sectionCopyValue += `\nSaturation: ${(saturation * 100).toFixed(0)}}%`
  }
  return sectionCopyValue
}

export default copy
